import { useContext } from 'react';
import { UpdateStatusWithNoteModalContext, UpdateStatusWithNoteModalContextType } from '@/contexts/UpdateStatusWithNoteModalContext';

export const useUpdateStatusWithNoteModalContext = (): UpdateStatusWithNoteModalContextType => {
  const context = useContext(UpdateStatusWithNoteModalContext);
  if (context === undefined) {
    throw new Error('useUpdateStatusWithNoteModalContext must be used within an UpdateStatusWithNoteModalContextProvider');
  }
  return context;
};
